<div class="dropdown-by-id">
  @if (!isMobile || enableMultiSelect) {
    <mat-form-field  appearance="outline"  class="dropdown-by-id__name-dropdown"
      [ngClass]="{'dropdown-by-id__remove-top-border': removeTopBorder}">
      <mat-label class="dropdown-by-id__custom-label">{{dropdownLabel}}</mat-label>
      @if (!enableMultiSelect) {
        <mat-select
          data-testid="dropdown-by-id"
          [disabled]="disabled"
          [(ngModel)]="selectedCategoryId"
          (selectionChange)="updateCategory(selectedCategoryId)">
          @for (category of categories; track category.id) {
            <mat-option
              class="dropdown-by-id__dropdown-options"
              [attr.data-testid]="category.name + '-option'"
              [disabled]="category.disabled"
              [ngClass]="{'dropdown-by-id__dropdown-options-disabled': category.disabled}"
              [value]="category.id">
              {{ category.name }}
            </mat-option>
          }
        </mat-select>
      }
      @if (enableMultiSelect) {
        <mat-select
          multiple
          [disabled]="disabled"
          data-testid="dropdown-by-id"
          [(ngModel)]="selectedCategoryIdsForMultiSelect"
          (selectionChange)="updateMultiSelectCategories(selectedCategoryIdsForMultiSelect)">
          @for (category of categories; track category.id) {
            <mat-option
              class="dropdown-by-id__dropdown-options"
              [attr.data-testid]="category.name + '-option'"
              [disabled]="category.disabled"
              [ngClass]="{'dropdown-by-id__dropdown-options-disabled': category.disabled}"
              [value]="category.id">
              {{ category.name }}
            </mat-option>
          }
        </mat-select>
      }
    </mat-form-field>
  }

  @if (isMobile && !enableMultiSelect) {
    <button type="button"
      class="dropdown-by-id__base-container cfa-plain-button"
      fxLayout="column"
      [ngClass]="{'dropdown-by-id__base-container-disabled': disabled}"
      (click)="openMobileSelectDropdown()"
     >
      <div class="dropdown-by-id__base-header-text" [ngClass]="{'dropdown-by-id__base-header-text-disabled': disabled}">
        {{dropdownLabel}}
      </div>
      <div fxLayout="row" fxLayoutAlign="start space-between">
        @for (category of categories; track category.id) {
          <div
            [ngClass]="{'dropdown-by-id__category': category.id === selectedCategoryId}">
            {{category.id === selectedCategoryId ? category.name : ''}}
          </div>
        }
        @if (!disabled) {
          <mat-icon class="dropdown-by-id__mobile-expand-arrow">expand_more</mat-icon>
        }
      </div>
    </button>
  }
</div>
